import { render, staticRenderFns } from "./XmlAuditDialog.vue?vue&type=template&id=20220e82&scoped=true"
import script from "./XmlAuditDialog.vue?vue&type=script&lang=js"
export * from "./XmlAuditDialog.vue?vue&type=script&lang=js"
import style0 from "./XmlAuditDialog.vue?vue&type=style&index=0&id=20220e82&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20220e82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20220e82')) {
      api.createRecord('20220e82', component.options)
    } else {
      api.reload('20220e82', component.options)
    }
    module.hot.accept("./XmlAuditDialog.vue?vue&type=template&id=20220e82&scoped=true", function () {
      api.rerender('20220e82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/XmlAuditDialog.vue"
export default component.exports